import request from '@/utils/request'
const BASE_URL = '/CpSendLog'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  //获取最新列表
  getLastList(data) {
    return request({
      url: BASE_URL + '/GetLastList',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  getLastSendMsg(memberType, memberId) {
    return request({
      url: BASE_URL + '/GetLastSendMsg',
      method: 'get',
      params: { memberType, memberId }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  saveList(data) {
    return request({
      url: BASE_URL + '/SaveList',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
}